import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={99}
    fill="none"
    {...props}
  >
    <path stroke="url(#awert)" strokeWidth={2} d="M29 1v96H1V1h28Z" />
    <path
      fill="url(#bwert)"
      d="M13.432 31.166v2.87h2.996v-2.87h-2.996Zm-1.26-1.176h5.572v5.208h-5.572V29.99Zm-3.094-3.304h11.858v12.46h-1.442V28.044H10.45v11.102H9.078v-12.46Zm.784 10.472H20.32v1.246H9.862v-1.246Z"
    />
    <path
      fill="url(#cwert)"
      d="M9.288 49.448h6.608v1.162H9.288v-1.162Zm2.674-1.386h1.246v5.516h-1.246v-5.516Zm-3.164 5.236a173.8 173.8 0 0 0 2.086-.336c.793-.13 1.629-.275 2.506-.434.887-.158 1.769-.317 2.646-.476l.084 1.162c-.83.159-1.666.318-2.506.476-.84.159-1.647.308-2.422.448-.765.15-1.465.28-2.1.392l-.294-1.232Zm.14-10.262h7.252v1.162H8.938v-1.162Zm4.228 1.974.952-.56c.252.308.509.644.77 1.008.27.364.518.724.742 1.078.233.346.415.654.546.924l-1.008.672a7.142 7.142 0 0 0-.518-.952 22.44 22.44 0 0 0-.728-1.106 17.47 17.47 0 0 0-.756-1.064Zm3.696-1.596h1.232v8.498h-1.232v-8.498Zm2.73-1.05h1.288v10.948c0 .383-.047.672-.14.868-.084.206-.243.364-.476.476-.243.094-.555.154-.938.182-.383.038-.84.056-1.372.056a3.481 3.481 0 0 0-.182-.644 4.21 4.21 0 0 0-.294-.644l1.106.028h.7c.121-.009.2-.032.238-.07.047-.046.07-.13.07-.252V42.364Zm-9.94 5.558a2.814 2.814 0 0 0-.112-.35c-.047-.149-.098-.303-.154-.462a2.015 2.015 0 0 0-.154-.392.997.997 0 0 0 .322-.21 4.09 4.09 0 0 0 .35-.406c.075-.112.196-.308.364-.588.168-.28.345-.611.532-.994.196-.382.364-.77.504-1.162l1.274.49c-.187.411-.401.822-.644 1.232-.233.411-.48.803-.742 1.176-.261.374-.518.705-.77.994v.028l-.126.07a3.036 3.036 0 0 0-.266.154c-.093.066-.182.14-.266.224-.075.075-.112.14-.112.196Zm0 0-.014-.924.644-.406 4.494-.336c.075.168.163.35.266.546l.294.49c-.933.084-1.722.154-2.366.21-.635.056-1.153.108-1.554.154-.392.038-.705.07-.938.098-.233.028-.41.056-.532.084-.112.028-.21.056-.294.084Z"
    />
    <path
      fill="url(#dwert)"
      d="M11.766 65.216v1.064h6.594v-1.064h-6.594Zm0 2.044v1.078h6.594V67.26h-6.594Zm0-4.074v1.05h6.594v-1.05h-6.594Zm-1.372-1.022h9.408v7.21h-9.408v-7.21Zm5.488 8.162.966-.854a39.328 39.328 0 0 1 3.234 1.232c.504.206.933.397 1.288.574l-1.288.896a14.325 14.325 0 0 0-1.162-.602c-.448-.214-.933-.429-1.456-.644a26.373 26.373 0 0 0-1.582-.602ZM9.106 59.854h11.732v1.218H9.106v-1.218Zm5.208.546 1.582.182c-.121.42-.252.831-.392 1.232-.13.392-.252.733-.364 1.022l-1.26-.224c.084-.317.168-.681.252-1.092.084-.42.145-.793.182-1.12Zm-1.344 8.988 1.176.882c-.41.243-.882.481-1.414.714-.532.234-1.078.448-1.638.644-.56.206-1.087.383-1.582.532a6.027 6.027 0 0 0-.91-1.022c.495-.14 1.017-.303 1.568-.49.55-.196 1.073-.401 1.568-.616.495-.224.905-.438 1.232-.644Z"
    />
    <path
      fill="url(#ewert)"
      d="M11.276 82.734h7.462v1.036h-7.462v-1.036Zm0 2.24h7.462v1.036h-7.462v-1.036Zm0 2.282h7.504v1.176h-7.504v-1.176Zm-2.562-9.184h12.614v1.232H8.714v-1.232Zm1.512 2.338h9.534v8.75h-1.372v-7.588h-6.846v7.588h-1.316v-8.75Zm4.102-1.638 1.666.07c-.15.42-.313.836-.49 1.246-.168.411-.327.766-.476 1.064l-1.288-.168a8.75 8.75 0 0 0 .238-.7c.075-.261.14-.522.196-.784.065-.27.117-.513.154-.728Zm3.318-2.632 1.498.35c-.261.392-.537.775-.826 1.148-.29.364-.56.677-.812.938l-1.162-.35c.159-.196.317-.415.476-.658.159-.242.308-.49.448-.742.15-.252.275-.48.378-.686Zm-6.594.476 1.176-.518c.261.243.518.523.77.84.252.308.443.579.574.812l-1.218.644a5.944 5.944 0 0 0-.56-.868 7.615 7.615 0 0 0-.742-.91Z"
    />
    <path fill="url(#f)" d="m15 8 6.928 12H8.072L15 8Z" />
    <defs>
      <linearGradient
        id="awert"
        x1={15}
        x2={15}
        y1={0}
        y2={98}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ADA273" />
        <stop offset={1} stopColor="#9B8876" />
      </linearGradient>
      <linearGradient
        id="bwert"
        x1={14.5}
        x2={14.5}
        y1={17.896}
        y2={45.69}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ADA273" />
        <stop offset={1} stopColor="#9B8876" />
      </linearGradient>
      <linearGradient
        id="cwert"
        x1={14.5}
        x2={14.5}
        y1={33.896}
        y2={61.69}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ADA273" />
        <stop offset={1} stopColor="#9B8876" />
      </linearGradient>
      <linearGradient
        id="dwert"
        x1={14.5}
        x2={14.5}
        y1={50.896}
        y2={78.69}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ADA273" />
        <stop offset={1} stopColor="#9B8876" />
      </linearGradient>
      <linearGradient
        id="ewert"
        x1={14.5}
        x2={14.5}
        y1={67.896}
        y2={95.69}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ADA273" />
        <stop offset={1} stopColor="#9B8876" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={15}
        x2={15}
        y1={8}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ADA273" />
        <stop offset={1} stopColor="#9B8876" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
